module.exports = __webpack_public_path__ + "img/jwgl-jcsj-jzgl.44d8210f.png";